import React from 'react';
import { Button, Dimmer, Loader, Modal, Message, Table } from 'semantic-ui-react';

const usageRows = usage => [
    { key: 'issues', label: 'Issues', value: usage.issues ?? 0 },
    { key: 'equipmentIssues', label: 'Equipment issues', value: usage.equipmentIssues ?? 0 },
    { key: 'componentIssues', label: 'Component issues', value: usage.componentIssues ?? 0 },
];

export const IssueOptionDeleteConfirmation = ({
    open,
    setOpen,
    item,
    singular,
    usage,
    usageError,
    usageLoading,
    deleting,
    onConfirm,
}) => {
    const blocked = !!usage && usage.total > 0;
    const confirmDisabled = usageLoading || !!usageError || !usage || blocked || deleting;

    return (
        <Modal open={open} onClose={() => !deleting && setOpen(false)} size="small">
            <Modal.Header>Delete {singular}</Modal.Header>
            <Modal.Content>
                {usageLoading && !usage && (
                    <div
                        style={{ position: 'relative', minHeight: '6rem' }}
                        data-testid="delete-usage-loading"
                    >
                        <Dimmer active inverted>
                            <Loader size="large" aria-label="Checking usage" />
                        </Dimmer>
                    </div>
                )}

                {usageError && (
                    <Message negative role="alert" data-testid="delete-usage-error">
                        <Message.Header>Couldn't check usage</Message.Header>
                        <p>Please close this dialog and try again.</p>
                    </Message>
                )}

                {usage && !usageError && blocked && (
                    <>
                        <Message negative role="alert" data-testid="delete-blocked">
                            <Message.Header>This {singular.toLowerCase()} can't be deleted</Message.Header>
                            <p>
                                It's in use by existing issues. Reassign or remove them before deleting.
                            </p>
                        </Message>
                        <Table basic compact aria-label="Where this is in use" data-testid="delete-usage-table">
                            <Table.Body>
                                {usageRows(usage).map(row => (
                                    <Table.Row key={row.key}>
                                        <Table.Cell>{row.label}</Table.Cell>
                                        <Table.Cell textAlign="right" data-testid={`delete-usage-${row.key}`}>
                                            {row.value}
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                                <Table.Row>
                                    <Table.Cell style={{ borderTop: '2px solid rgba(34,36,38,.15)' }}>
                                        <strong>Total</strong>
                                    </Table.Cell>
                                    <Table.Cell
                                        textAlign="right"
                                        style={{ borderTop: '2px solid rgba(34,36,38,.15)' }}
                                        data-testid="delete-usage-total"
                                    >
                                        <strong>{usage.total}</strong>
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </>
                )}

                {usage && !usageError && !blocked && (
                    <p data-testid="delete-target">
                        You are about to permanently delete "<strong>{item?.name}</strong>". This cannot be undone.
                    </p>
                )}
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => setOpen(false)} disabled={deleting} data-testid="delete-cancel">
                    Cancel
                </Button>
                <Button
                    negative
                    onClick={onConfirm}
                    loading={deleting}
                    disabled={confirmDisabled}
                    data-testid="delete-confirm"
                >
                    Delete
                </Button>
            </Modal.Actions>
        </Modal>
    );
};
